import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MplButton, MplModal } from '../../../';

export interface ConfirmationModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isCanceling: boolean;
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
	open,
	onClose,
	onConfirm,
	isCanceling,
}) => {
	const { t } = useTranslation('tickets');

	return (
		<MplModal
			open={open}
			testId="ConfirmationModal-MplModal"
			onBackDropClick={onClose}
			title={t('text.remove_ride')}
			content={t('text.remove_lbt_text')}
			buttons={
				<>
					<MplButton
						fullWidth
						variant="outlined"
						onClick={onClose}
						disabled={isCanceling}
						testId="BookingCancellationFlow-ConfirmRemoveStep-CancelButton"
					>
						{t('button.abort')}
					</MplButton>
					<MplButton
						fullWidth
						onClick={onConfirm}
						showLoader={isCanceling}
						disabled={isCanceling}
						testId="BookingCancellationFlow-ConfirmRemoveStep-ConfirmButton"
					>
						{t('button.remove')}
					</MplButton>
				</>
			}
		/>
	);
};
